import script from "./errorMsg.vue?vue&type=script&lang=js"
export * from "./errorMsg.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__